import {
  Form,
  SpaceBetween,
  Button,
  FormField,
  Input,
  Toggle,
} from '@cloudscape-design/components';
import { Location } from '@amzn/gbsa-helios-typescript-client';

interface LocationDetailsFormProps {
  location: Location;
  onViewDismiss: () => void;
}

export function LocationDetailsFormView({
  location,
  onViewDismiss,
}: LocationDetailsFormProps) {
  const handleClose = () => {
    onViewDismiss();
  };

  return (
    <Form
      actions={
        <SpaceBetween direction="horizontal" size="xs">
          <Button data-testid="close-button" variant="link" onClick={handleClose}>
            Close
          </Button>
        </SpaceBetween>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <FormField data-testid="locationCode-field" label="Location">
          <Input
            readOnly
            data-testid="locationCode-input"
            value={location.locationCode}
          />
        </FormField>
        <FormField data-testid="businessUnitId-field" label="Business Unit">
          <Input
            readOnly
            data-testid="businessUnit-input"
            value={location.businessUnitId}
          />
        </FormField>
        <FormField data-testid="region-field" label="Region">
          <Input readOnly data-testid="region-input" value={location.region} />
        </FormField>
        <FormField data-testid="country-field" label="Country">
          <Input readOnly data-testid="country-input" value={location.country} />
        </FormField>
        <FormField label="Status" constraintText="Current status of the location.">
          <Toggle
            data-testid="enabled-toggle"
            checked={!!location.isEnabledForBU}
            readOnly
          >
            {location?.isEnabledForBU ? 'Active' : 'Inactive'}
          </Toggle>
        </FormField>
      </SpaceBetween>
    </Form>
  );
}
